export default function ActivityFeedIcon() {
  return (
    <svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4961_480)">
        <path
          d="M4.0625 7H21.9375"
          stroke="#FDFAEE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.0625 14H10.5625"
          stroke="#FDFAEE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.0625 21H12.1875"
          stroke="#FDFAEE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5 15.75C19.5 15.0538 19.7568 14.3861 20.2139 13.8938C20.671 13.4016 21.291 13.125 21.9375 13.125C22.584 13.125 23.204 13.4016 23.6611 13.8938C24.1182 14.3861 24.375 15.0538 24.375 15.75C24.375 19.25 19.5 21.875 19.5 21.875C19.5 21.875 14.625 19.25 14.625 15.75C14.625 15.0538 14.8818 14.3861 15.3389 13.8938C15.796 13.4016 16.416 13.125 17.0625 13.125C17.709 13.125 18.329 13.4016 18.7861 13.8938C19.2432 14.3861 19.5 15.0538 19.5 15.75Z"
          stroke="#FDFAEE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4961_480">
          <rect width="26" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
